import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPosts } from "./postsAPI";

const initialState = {
  isLoading: false,
  posts: [],
  error: "",
};

export const fetchPosts = createAsyncThunk(
  "posts/fetchPosts",
  async ({ filter, sort }) => {
    const posts = await getPosts(filter, sort);
    return posts;
  }
);

export const postsSlice = createSlice({
  name: "posts",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => {
        state.isLoading = true;
        state.posts = [];
        state.error = "";
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.posts = action.payload;
        state.error = "";
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.posts = [];
        state.error = action.error?.message;
      });
  },
});

export default postsSlice.reducer;
